import React, { useEffect, useState, useRef, useContext } from "react";
import Logo from "../../images/MY-Anlook.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import MyContext from "../../MyContext";

const Navbar = ({ onSignUpClick, onLoginClick }) => {
  const { baseUrl, config } = useContext(MyContext);
  const navigate = useNavigate();

  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuWrapperRef = useRef(null);

  const [plans, setPlans] = useState([]);
  const [sessionID, setSessionId] = useState("");
  const [campaignIdHook, setCampaignIdHook] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!menuOpen) return;

      if (
        menuWrapperRef.current &&
        !menuWrapperRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  const generateUUID = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );

  useEffect(() => {
    const storedSessionID = sessionStorage.getItem("sessionID");
    if (storedSessionID) {
      setSessionId(storedSessionID);
    } else {
      const newSessionID = generateUUID();
      sessionStorage.setItem("sessionID", newSessionID);
      setSessionId(newSessionID);
    }
  }, []);

  useEffect(() => {
    let params = new URLSearchParams(window.location.search);
    let campaignid = params.get("campaignid");

    if (!campaignid) {
      params = new URLSearchParams(window.location.hash.substring(1));
      campaignid = params.get("campaignid");
    }

    if (campaignid) {
      sessionStorage.setItem("campaignId", campaignid);
      setCampaignIdHook(campaignid);
    }
  }, []);

  const fetchSubscriptionPlans = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Entitlement/fetchSubscriptionPlans`,
        { userid: "", countryCode: "IN" },
        config
      );
      setPlans(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  useEffect(() => {
    if (sessionID) fetchSubscriptionPlans();
  }, [sessionID]);

  const trackClick = async (buttonName) => {
    try {
      await axios.post(`${baseUrl}/api/Blog/trackClickHeatMaps`, {
        campaignid: campaignIdHook,
        sessionid: sessionID,
        element: "Button",
        button_name: buttonName,
        pageurl: window.location.href,
        pagename: "Navbar",
        product: "Anlook",
      });
    } catch (error) {
      console.error("SEO track error:", error);
    }
  };

  const handleGetStarted = async () => {
    await trackClick("Get Started");
    navigate("/get/GetStarted", { state: { plan: plans } });
  };

  useEffect(() => {
  if (menuOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
}, [menuOpen]);

  return (
    <>
      <div className={`ln-wrap ${scrolled ? "scrolled" : ""}`}>
        <div className="ln-container">
          <div className="ln-inner" ref={menuWrapperRef}>
            <Link to="/">
              <img src={Logo} alt="Logo" className="ln-logo" />
            </Link>

            {/* DESKTOP LINKS */}
            <div className="ln-links">
              <Link to="/" className="ln-link">
                Home
              </Link>
              <Link to="/about-us" className="ln-link">
                About
              </Link>
              <Link to="/pricing-page" className="ln-link">
                Pricing
              </Link>
              <Link to="/blog" className="ln-link">
                Blogs
              </Link>
              <Link to="/contact" className="ln-link">
                Contact us
              </Link>
            </div>

            {/* DESKTOP */}
            <div className="ln-desktop-actions">
              <button className="ln-btn" onClick={handleGetStarted}>
                Get Started
              </button>

             

              <button
                className="btn bg-success text-white px-4"
                onClick={onLoginClick}
              >
                Login
              </button>
            </div>

            <div
              className="ln-hamburger"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              ☰
            </div>
        

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="ln-mobile-menu">
          <Link to="/" onClick={() => setMenuOpen(false)}>
            Home
          </Link>
          <Link to="/about-us" onClick={() => setMenuOpen(false)}>
            About
          </Link>
          <Link to="/pricing-page" onClick={() => setMenuOpen(false)}>
            Pricing
          </Link>
          <Link to="/blog" onClick={() => setMenuOpen(false)}>
            Blogs
          </Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)}>
            Contact us
          </Link>

          <div className="mobile-actions">
            {/* <button
              className="btn text-white"
              style={{ backgroundColor: "rgba(1, 195, 125, 1)" }}
              onClick={onSignUpClick}
            >
              Sign Up
            </button> */}

            <button
  className="btn bg-success text-white px-4"
  onClick={onLoginClick}
>
  Login 
</button>

            <button
              className="ln-btn"
              onClick={() => {
                setMenuOpen(false);
                handleGetStarted();
              }}
            >
              Get Started
            </button>
          </div>
        </div>
      )}
</div>
</div>
</div>
      <style>{`
        .ln-wrap {
          position: sticky;
          top: 0;
          height: 75px;
          background: #F1F5F1;
          z-index: 500;
            pointer-events: auto;
        }

        .ln-wrap.scrolled {
  pointer-events: auto;
}

        .ln-container {
          max-width: 1400px;
          margin: auto;
          padding: 0 5rem;
        }

        .ln-inner {
          height: 75px;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .ln-logo { width: 160px; }

        .ln-links {
          display: flex;
          gap: 32px;
        }

        .ln-link {
          text-decoration: none;
          color: #2c2c2c;
          font-weight: 500;
        }

        .ln-btn {
          background: #01C37D;
          color: #fff;
          border: none;
          padding: 8px 22px;
          border-radius: 8px;
          font-weight: 600;
        }

        .ln-desktop-actions {
          display: flex;
          gap: 10px;
        }

        .ln-hamburger {
          display: none;
          font-size: 26px;
          cursor: pointer;
        }

        .ln-mobile-menu {
          position: fixed;
          top: 75px;
          left: 0;
          width: 100%;
          background: white;
          padding: 20px;
          text-align: center;
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
          z-index: 2000;
        }

        .ln-mobile-menu a {
          display: block;
          padding: 12px;
          font-size: 18px;
          text-decoration: none;
          color: #141414;
        }

        .mobile-actions {
          display: flex;
          flex-direction: column;
          gap: 14px;
          margin-top: 20px;
        }

        .mobile-actions button {
          width: 100%;
          padding: 12px;
          font-size: 16px;
        }

        @media (max-width: 992px) {
          .ln-links,
          .ln-desktop-actions {
            display: none;
          }

          .ln-hamburger {
            display: block;
          }

          .ln-container {
            padding: 0 1.5rem;
          }
        }
      `}</style>
    </>
  );
};

export default Navbar;